module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 1rem 0"
    }
  }, [_vm._l((_vm.pageData), function(row, index) {
    return (_vm.pageData.length > 0) ? _c('div', [_c('van-divider', [_vm._v("人员信息" + _vm._s(index + 1))]), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
      attrs: {
        "title": "姓名",
        "value": row.name
      }
    }), _vm._v(" "), _c('van-cell', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (row.code),
        expression: "row.code"
      }],
      attrs: {
        "title": "编号",
        "value": row.code
      }
    }), _vm._v(" "), _c('van-cell', {
      attrs: {
        "title": "身份证",
        "value": row.num
      }
    }), _vm._v(" "), _c('van-cell', {
      attrs: {
        "title": "电话",
        "value": row.phone
      }
    }), _vm._v(" "), _c('van-cell', {
      attrs: {
        "title": "微信",
        "value": row.weixin
      }
    }), _vm._v(" "), _c('van-cell', {
      attrs: {
        "title": "等级",
        "value": row.grade_name
      }
    }), _vm._v(" "), _c('van-cell', {
      attrs: {
        "title": "注册日期",
        "value": _vm._f("timeFormat")(row.regist_date)
      }
    })], 1)], 1) : _vm._e()
  }), _vm._v(" "), (_vm.pageData.length == 0) ? _c('div', [_c('van-empty', {
    attrs: {
      "description": "暂无数据"
    }
  })], 1) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49538cf5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/weiyuanhui/apps/member/CaipanDetail.vue
// module id = 2367
// module chunks = 0